module.exports = __webpack_public_path__ + "static/img/repast03.b103ed3a.jpg";